import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { KdButton } from 'kuaidong-ui'
import { ColorUtil } from 'kuaidong-lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitPrice',
  props: {
    styles: { default: () => ({
      color: '#fff',
      fontSize: 16,
    }) },
    product: null
  },
  setup(__props: any) {

const props = __props as { styles: {
      color?: string
      width?: number
      height?: number
      fontSize?: number
      originalPriceColor?: string
    }, product: {
      is_promotion: boolean
      original_price: number
      promotion_price: number
    } };



const unitPrice = computed(() =>
  props.product.is_promotion ? props.product.promotion_price : props.product.original_price
)

const originalPriceColor = computed(
  () => props.styles.originalPriceColor || (props.styles.color && ColorUtil.hex2RGBA(props.styles.color, 50))
)

const originalPriceFontSize = computed(() => Math.max(props.styles.fontSize ? props.styles.fontSize - 2 : 14, 12))

return { __sfc: true,props, unitPrice, originalPriceColor, originalPriceFontSize, KdButton }
}

})